import { render, staticRenderFns } from "./testPanel.vue?vue&type=template&id=1e4687f0&"
import script from "./testPanel.vue?vue&type=script&lang=js&"
export * from "./testPanel.vue?vue&type=script&lang=js&"
import style0 from "./testPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports